import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { select, Store } from "@ngrx/store";

import { selectorAuth } from "@app/core";

@Injectable()
export class AdminGuardService {
  private store = inject<Store<any>>(Store);
  router = inject(Router);

  isAuthenticated = false;
  isAdmin = false;
  isPlanner = false;

  constructor() {
    this.store.pipe(select(selectorAuth)).subscribe((auth) => {
      // Reset on every emission so cleared auth (logout/expiry) revokes
      // access instead of leaving stale flags behind.
      this.isAuthenticated = !!auth && auth.isAuthenticated;
      this.isAdmin = !!auth && auth.isAdmin;
      this.isPlanner = !!auth && auth.isPlanner;
    });
  }

  canActivate(): boolean {
    // console.log("admin guard eval", this.isAdmin);
    if (this.isAuthenticated === false || this.isAdmin === false) {
      this.router.navigate(["/", "denied"]).then();
      return false;
    }
    return true;
  }
}
